var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "viq-pdf-export" },
    [
      _c(
        "el-button",
        {
          attrs: { loading: _vm.exporting, size: "small", type: "primary" },
          on: { click: _vm.exportPdf },
        },
        [
          !_vm.exporting
            ? _c(
                "svg",
                {
                  staticStyle: {
                    "margin-right": "6px",
                    "vertical-align": "middle",
                  },
                  attrs: {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 14 14",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M12 9v3H2V9M7 1v8M4 5l3 3 3-3",
                      stroke: "currentColor",
                      "stroke-width": "1.2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v("\n    Export PDF\n  "),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }